module.exports = __webpack_public_path__ + "static/media/p-logo-visa.840aa04b.svg";